(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-bh-trimmer]').forEach(section => {
      if (section.dataset.bhReady) return;
      section.dataset.bhReady = 'true';
      const radios = [...section.querySelectorAll('[data-bh-offer]')];
      const sync = () => {
        const selected = radios.find(input => input.checked);
        if (!selected) return;
        const price = selected.dataset.price;
        section.querySelectorAll('[data-bh-main-price],[data-bh-button-price]').forEach(el => {el.textContent = price;});
        const variant = section.querySelector('[data-bh-variant]');
        if (variant) variant.value = selected.value;
        const add = section.querySelector('[data-bh-add]');
        if (add) {
          add.disabled = selected.dataset.available !== 'true';
          add.firstChild.textContent = (add.disabled ? add.dataset.soldLabel : add.dataset.addLabel) + ' ';
        }
      };
      radios.forEach(radio => radio.addEventListener('change', sync));
      sync();
    });
    root.querySelectorAll('.bh-purchase-form').forEach(form => {
      if (form.dataset.bhReady) return;
      form.dataset.bhReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy) return;
        const button = form.querySelector('button[type=submit]');
        const error = form.querySelector('[data-bh-cart-error]');
        const source = document.querySelector('[data-bh-copy]');
        if (button.disabled) return;
        form.dataset.busy = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy','true');
        if (error) error.hidden = true;
        const controller = new AbortController();
        let timer;
        try {
          const marketReady = await (window.haloMarketReady || Promise.resolve(true));
          if (!marketReady) throw new Error(source?.dataset.marketError || 'Choose your shipping country before adding this item.');
          timer = setTimeout(() => controller.abort(), 15000);
          const shopRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(shopRoot + 'cart/add.js', {method:'POST', body:new FormData(form), signal:controller.signal, headers:{Accept:'application/json'}});
          const body = await response.json();
          if (!response.ok) throw new Error(body.description || body.message || source?.dataset.cartError);
          window.location.assign(shopRoot + 'cart');
        } catch (problem) {
          if (error) {
            error.textContent = problem.name === 'AbortError' ? source?.dataset.timeoutError : (problem.message || source?.dataset.cartError);
            error.hidden = false;
            error.tabIndex = -1;
            error.focus();
          }
          button.disabled = false;
          button.removeAttribute('aria-busy');
          delete form.dataset.busy;
        } finally { clearTimeout(timer); }
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.bh-menu[open]').forEach(menu => {menu.open = false;menu.querySelector('summary').focus();});
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.bh-purchase-form[data-busy]').forEach(form => {
      delete form.dataset.busy;
      const button = form.querySelector('button[type=submit]');
      button.disabled = false;button.removeAttribute('aria-busy');
    });
  });
})();
